export const VIEWER_ACTION_TYPES = {
  VIEWER_IDENTIFIED: 'VIEWER_IDENTIFIED',
  VIEWER_FINISHED: 'VIEWER_FINISHED',
  VIEWER_IDENTIFIED_CHIRP: 'VIEWER_IDENTIFIED_CHIRP',
  VIEWER_FINISH_SESSION_CHIRP: 'VIEWER_FINISH_SESSION_CHIRP',
  VIEWER_DOWNLOADED_CHIRP: 'VIEWER_DOWNLOADED_CHIRP'
};